module.exports = __webpack_public_path__ + "static/img/13.db18501.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/sp/13.png
// module id = PXcY
// module chunks = 0